import { IConsentForm } from "@/api/dtos";
import { IFormSingleResponse, OnlinePatientManagementContext } from "@ngt/opms";
import { useCallback, useContext, useMemo } from "react";
import { KeyedMutator } from "swr";
import { EConsentUserType } from "@/contexts/EConsentContext";


const useEConsentFormSave =  <TData extends IConsentForm = IConsentForm>(
    formTypeName?: string,
    guid?: string,
    mutate?: KeyedMutator<IFormSingleResponse<TData>>,
    userType?: EConsentUserType | null,
    patientId?: number
) => {
    const {serviceStackClient, dtos} = useContext(OnlinePatientManagementContext);

    const formDto = useMemo(() => {
        const suffix = userType === EConsentUserType.Investigator
            ? "EConsentInvestigatorPostSubmit"
            : "EConsentFormPostSubmit";
        return dtos[`${formTypeName}${suffix}`];
    }, [dtos, formTypeName, userType])

    const save = useCallback(async (saveData: TData, _shouldRevalidate?: boolean) => {
        if (!formDto || (userType === EConsentUserType.Investigator ? !patientId : !guid)) {
            return;
        }

        const request = userType === EConsentUserType.Investigator
            ? new formDto({ patientId, form: saveData })
            : new formDto({ form: saveData, guid });
        await serviceStackClient.post(request)

        if (mutate) {
            const mutated = await mutate(undefined, { revalidate: true });

            return mutated?.form;
        }

        return saveData;
    }, [serviceStackClient, formDto, guid, mutate, patientId, userType]);

    return save;
};

export default useEConsentFormSave;
